import React from 'react';
import styled from 'styled-components';
import {
    Nav,
    HeartFilled,
    DownloadCircleFilled,
    FolderFilled,
    useBreakpoint,
    palette,
    Tooltip,
    ProductHeader,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { RoutePaths } from 'types/enums';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { getIsCurrentPath } from 'helpers';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import RemainingCredits from './RemainingCredits';

const StyledNavItem = styled(Nav.Item)`
    ${({ theme }): string => theme.breakpoint('md')`
        &:first-child,
        &:last-child {
            border-top: 1px solid ${palette('neutral.800')};
        }
    `}
`;

export const AuthenticatedNavigation = ({
    onClick,
}: {
    onClick: () => void;
}) => {
    const isMobile = useBreakpoint('md');
    const isSmallDesktop = useBreakpoint('lg');
    const showOnlyIcon = !isMobile && isSmallDesktop;

    const toLocalizedPath = useToLocalizedPath();

    const privateRoutes = [
        {
            path: toLocalizedPath(`/${RoutePaths.Favorites}`),
            text: t`Favorites`,
            icon: HeartFilled,
        },
        {
            path: toLocalizedPath(`/${RoutePaths.Downloads}`),
            text: t`Downloads`,
            icon: DownloadCircleFilled,
        },
        {
            path: toLocalizedPath(`/${RoutePaths.Collections}`),
            text: t`Collections`,
            icon: FolderFilled,
        },
    ];

    return (
        <ProductHeader.Nav
            key="authenticated"
            useOverflow={false}
            sx={{ minWidth: 'fit-content', width: 'auto', flex: '0 1 auto' }}
        >
            {privateRoutes.map(({ path, icon: Icon, text }) => (
                <StyledNavItem key={text}>
                    <Nav.Link
                        as={RouterLink}
                        to={path}
                        icon={!showOnlyIcon && Icon}
                        onClick={onClick}
                        isCurrent={getIsCurrentPath(path)}
                    >
                        {!showOnlyIcon && text}
                        {showOnlyIcon && (
                            <Tooltip content={text} position="top" hasArrow>
                                <Icon />
                            </Tooltip>
                        )}
                    </Nav.Link>
                </StyledNavItem>
            ))}
            <StyledNavItem key={'credit-balance'}>
                <RemainingCredits onClick={onClick} />
            </StyledNavItem>
        </ProductHeader.Nav>
    );
};
